module.exports = __webpack_public_path__ + "img/tooltip_03-vallone-nano-grigio-londra-02.37e282e4.jpg";